var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebabMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C11.45 20 10.9793 19.8043 10.588 19.413C10.1967 19.0217 10.0007 18.5507 10 18C9.99934 17.4493 10.1953 16.9787 10.588 16.588C10.9807 16.1973 11.4513 16.0013 12 16C12.5487 15.9987 13.0197 16.1947 13.413 16.588C13.8063 16.9813 14.002 17.452 14 18C13.998 18.548 13.8023 19.019 13.413 19.413C13.0237 19.807 12.5527 20.0027 12 20ZM12 14C11.45 14 10.9793 13.8043 10.588 13.413C10.1967 13.0217 10.0007 12.5507 10 12C9.99934 11.4493 10.1953 10.9787 10.588 10.588C10.9807 10.1973 11.4513 10.0013 12 10C12.5487 9.99867 13.0197 10.1947 13.413 10.588C13.8063 10.9813 14.002 11.452 14 12C13.998 12.548 13.8023 13.019 13.413 13.413C13.0237 13.807 12.5527 14.0027 12 14ZM12 8.00001C11.45 8.00001 10.9793 7.80434 10.588 7.41301C10.1967 7.02167 10.0007 6.55067 10 6.00001C9.99934 5.44934 10.1953 4.97867 10.588 4.58801C10.9807 4.19734 11.4513 4.00134 12 4.00001C12.5487 3.99867 13.0197 4.19467 13.413 4.58801C13.8063 4.98134 14.002 5.45201 14 6.00001C13.998 6.54801 13.8023 7.01901 13.413 7.41301C13.0237 7.80701 12.5527 8.00267 12 8.00001Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabMenu);
export default __webpack_public_path__ + "static/media/kebabMenu.369f3751bdd1e3178f2423edaed023b4.svg";
export { ForwardRef as ReactComponent };